/**
 * Affiche le prénom de l'utilisateur stocké dans le localStorage sur la page de remerciement.
 *
 * @description Cette fonction récupère les informations utilisateur depuis localStorage,
 * puis affiche le prénom de l'utilisateur dans l'élément HTML avec l'ID 'thanksName'.
 * Si l'élément n'existe pas ou si le prénom n'est pas disponible, aucun changement n'est effectué.
 *
 */
export function getUserFromLocalStorage() {
    const localStorageUser = localStorage.getItem('user');
    if (!localStorageUser) {
        console.warn("⚠️ Aucune donnée 'user' trouvée dans localStorage.");
        return;
    }

    let userObj;
    try {
        userObj = JSON.parse(localStorageUser);
    } catch (e) {
        console.error("❌ Impossible de parser l'utilisateur depuis localStorage", e);
        return;
    }

    if (!userObj.fname) {
        console.warn("⚠️ Nom de l'utilisateur introuvable dans l'objet localStorage.");
        return;
    }

    return userObj;
}

/**
 * Lie l'input #firstName au localStorage pour l'utiliser dans la page de remerciement
 */
export function bindLocalStorageFnamToInput() {
    const firstNameInput = document.getElementById("firstName");
    if (!firstNameInput) {
        console.warn("⚠️ Impossible d’initialiser la synchronisation du stockage local : élément #firstName introuvable.");
        return;
    }

    firstNameInput.addEventListener('change', () => {
        localStorage.user = JSON.stringify({ fname: firstNameInput.value });
    });
}
